import { Grid } from "@mui/material";
import { motion } from "motion/react";
import { AddAnElementCard } from "~/components/add-an-element-card";
import { ActiveIntegrationSummaryCard } from "./ActiveIntegrationSummaryCard";
import { fadeInOut } from "~/lib/animations";
import { activeSummaries } from "~/lib/integrations";
import { IntegrationType, IntegrationTypeSummary } from "~/operations";
import { CanCreate } from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";

type Props = {
  scope: SpaceScope | OrganizationScope;
  summaries: IntegrationTypeSummary[];
};

export function ActiveIntegrations({ scope, summaries }: Props) {
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <Grid
      container
      spacing={3}
      component={motion.div}
      {...fadeInOut}
      key="active-integrations"
    >
      {activeSummaries(summaries).map((integration) => (
        <Grid
          key={integration.type}
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <ActiveIntegrationSummaryCard {...{ scope, integration }} />
        </Grid>
      ))}
      <CanCreate>
        <Grid
          sx={{ display: "flex" }}
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        >
          <AddAnElementCard
            label="add another integration"
            to={`add?${scope.params}`}
            minHeight={173}
          />
        </Grid>
      </CanCreate>
    </Grid>
  );
}
